import React from 'react';
import ChatPanel from './panels/ChatPanel';

// Public entry (AntChatWorkspace): full page ('embed') or floating panel; defaults to floating.
export default function ChatFloating(props) {
    return <ChatPanel {...props} mode={props.mode || 'floating'} />;
}
